module.exports = __webpack_public_path__ + "img/undraw_Photo_sharing_re_jip7.b1878aed.svg";